import DefaultModal from '../defaultModal/DefaultModal';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import InfoContentTab from '../../../pages/infoContent/components/InfoContentTab';

function TermsModal() {
  const { width } = useWindowDimensions();
  const { showTermsModal, setShowTermsModal } = useModal();

  return (
    <DefaultModal
      show={showTermsModal && width >= 1024}
      setShow={setShowTermsModal}
      className="ticket-refund-modal"
    >
      <InfoContentTab type={showTermsModal} />
    </DefaultModal>
  );
}

export default TermsModal;
